<template src="./html/Values.html"></template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	import Value from './Value'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
			'value': Value,
		},
		data () {
			return {
				modal: {
					selector: 'modal-values-product-attribute-' + new Date().getTime(),
				},
				loading: false,
				types: null,
				item: null,
				values: null,
				editMode: false,
			}
		},
		methods: {
			open(item) {
				this.item = null
				this.values = null
				this.editMode = false
				if(item) {
					this.item = item
					this.getValues()
				}
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.errors.clear()
			},
			reload() {
				this.editMode = false
				this.getValues()
			},
			changeEditMode(editMode) {
				this.editMode = editMode
			},
			getValues() {
				this.values = null
				this.loading = true
				this.$http.get('admin/management/products/attribute/lists/' + this.item.id  + '/values')
				.then(response => {
					this.values = response.body
					this.loading = false
				})
			},
			remove(item) {
				this.editMode = false
				let index = this.values.indexOf(item)
				this.values.splice(index, 1)
			},
			addItem() {
				var value = {
					name: null,
					value: null,
					product_attribute_list_id: this.item.id,
				}
				this.values.push(value)
				this.$nextTick( () => $('#table-values tr:last td:first input').focus())
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Values.vue